module.exports = __webpack_public_path__ + "img/MAC320_R.60f0c5cc.png";